export const api = {
    login: '/api/auth',
    logout: '/api/logout',
    eventListG: '/api/guest/events',
    raceListG: '/api/guest/races',
    eventListNewG: '/api/guest/event_list',
    eventDetailG: '/api/guest/event',
    eventList: '/api/client/events',
    eventListNew: '/api/client/event_list',
    raceList: '/api/client/races',
    eventDetail: '/api/client/event',
    eventDetailOnly: '/api/client/event_detail',
    odds: '/ws/getMarketData',
    oddsNew: '/ws/getMarketDataNew',
    exposure: '/api/client/exposes',
    accountStmt: '/api/client/report/statement',
    profitLoss: '/api/client/report/profit_loss',
    profitLossDetail: '/api/client/report/profit_loss_detail',
    betHistory: '/api/client/report/order_history',
    fancyRunPosition: '/api/client/fancy_run_position',
    scoreData: '/ws/getScoreData',
    tvData: '/api/client/stream',
    //userData: '/ws/getUserData',
    placeBet: '/api/client/store_order',
    orderList: '/api/client/orders',
    deletedOrderList: '/api/client/report/settled/deleted_order_history',
    stakesUpdate: '/api/client/update_stakes',
    casinoAll: '/api/client/all_casino',
    casinoAllG: '/api/guest/all_casino',
   casino1: '/api/client/casino_1',
    casino1G: '/api/guest/casino_1',
    //casinoIList: '/api/client/casino_i_list_new',
    casinoIList: '/api/client/casino_i_list',
    //casinoIListG: '/api/guest/casino_i',
    casinoIListG: '/api/guest/casino_i_list',
    casinoIntList: '/api/client/casino_int_list_new',
    casinoIntListG: '/api/guest/casino_int',
    // casinoITbl: '/api/client/casino_i',
    casinoITbl: '/api/client/all_casino',
    casinoIntTbl: '/api/client/casino_int_new',
    changePass: '/api/change_password',
    myProfile: '/api/client/profile',
    rules: '/api/client/rules',
    menu: '/api/guest/menu',
    marketAnalysis: '/api/client/market-analysis',
    multiMarket: '/api/client/multi-market',
    saveMultiMarket: '/save',
    removeMultiMarket: '/remove',
    eventTypeIds: '/api/client/event-type-id/list',
    cashOut: '/api/client/cash-out',
    sportReport: '/api/client/report/sports',
    bannerList: '/api/guest/sliders',
    deposit: '/api/client/get_deposit',
    withdraw: '/api/client/get_withdraw',
    bonusList: '/api/client/bonus-list',
    bonusRedeem: '/api/client/bonus-redeem',
    bonusRules: '/api/client/bonus_rules',
    refferAndEarn: '/api/client/refer-and-earn',
    frontendConfig: '/api/client/frontend_config',
    frontendConfigG: '/api/guest/frontend_config',
    // ftLivetvData: 'https://getscoredata.com/score/c0ac7318db29c11f11afbb4482ffe1523822c6ee/',
    ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
};
